import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "colbi_web_ui/lib/style/variableInjector.scss";
import "colbi_web_ui/lib/style/index.sass";
import "mosaic-react/installLicense";

import "./polyfills/object.entries.js";

import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter as Router } from "react-router-dom";
import { Provider, useSelector } from "react-redux";

import CheckPermissionsRouting from "./components/CheckPermissionsRouting";
import configureStore from "./store";
import { fetchAction } from "./store/actions";
import * as serviceWorker from "./serviceWorker";
import HeadChange from "./components/HeadChange.js";
import { OidcProviderContext } from "./state/oidcProviderContext.js";
import { loadConfig } from "./config/config.js";
import NotFound from "./controllers/NotFound/NotFound.js";
import { SovosProvider } from "mosaic-react";
import { SovosPlatformProvider } from "mosaic-react-platform";
import environmentIndex from "./components/environmentSovosPlatform.json";
import assetResolver, { assetKeys } from "mosaic-assets-resolver";

export const { store, persistor } = configureStore({});

const SovosPlatformProviderWithLocale = ({ children, environment, onLoadingComplete, theme }) => {
    const locale = useSelector((state) => state.locale) || "en";
    return (
        <SovosPlatformProvider
            suiteKey="tax"
            productKey="saft"
            lng={locale}
            environment={environment}
            onLoadingComplete={onLoadingComplete}
            theme={theme}
        >
            {children}
        </SovosPlatformProvider>
    );
};

loadConfig()
    .then((configs) => (window.saftEnvVariables = configs))
    .then(() => {
        const { REACT_APP_ENVIRONMENT_TYPE } = window.saftEnvVariables;
        const environmentProductSwitcherSetup =
            environmentIndex[REACT_APP_ENVIRONMENT_TYPE] || "dev";
        const theme = assetResolver.theme(assetKeys.themes.brown);
        const onLoadingComplete = () => {
            if (REACT_APP_ENVIRONMENT_TYPE === "rac") {
                const productSwitcherButton = document.querySelector(
                    '[data-testid="sovosProductMenu__button"]',
                );
                if (productSwitcherButton) {
                    productSwitcherButton.onclick = (e) => {
                        e.stopPropagation();
                    };
                }
            }
        };

        ReactDOM.createRoot(document.getElementById("root")).render(
            <OidcProviderContext>
                <SovosProvider>
                    <Provider store={store}>
                        <Router>
                            <SovosPlatformProviderWithLocale
                                environment={environmentProductSwitcherSetup}
                                onLoadingComplete={onLoadingComplete}
                                theme={theme}
                            >
                                <HeadChange />
                                <CheckPermissionsRouting store={store} fetchAction={fetchAction} />
                            </SovosPlatformProviderWithLocale>
                        </Router>
                    </Provider>
                </SovosProvider>
            </OidcProviderContext>,
        );
    })
    .catch((e) => {
        console.error("Failed to fetch config: ", e);
        ReactDOM.createRoot(document.getElementById("root")).render(
            <Provider store={store}>
                <NotFound match={{ params: { locale: "en" } }} />
            </Provider>,
        );
    });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
